<ng-container>
  <div class="ppl-container-body">
    <div class="ppl-container-head">
      <h1 class="page-title-accessibility">Payroll Processing</h1>
      @if (!isReadOnly) {
        <div class="action">
          <ppl-button
            label="New Payroll Processing"
            icon="fa fa-plus"
            [customClass]="'primary-button'"
            [iconPosition]="'left'"
            (handleClick)="onNewBatch()"
          ></ppl-button>
        </div>
      }
    </div>
    <div class="ppl-container">
      <div class="ppl-content-container">
        <div class="table-style">
          @if (programName) {
            <ppl-list-table
              [pageConfig]="programName"
              [loadPage]="lazyLoad"
              [sharedDataKey]="sharedDataKey"
              [jsonList]="'list_timesheet_payroll_runs'"
              [tableWidth]="'100%'"
              [tableScrollable]="true"
              tableScrollHeight="flex"
              [dataLoader]="payrollRunsDataLoader"
              [recordsPerPage]="20"
              [enableActions]="!isReadOnly"
              [enablePageActions]="!isReadOnly"
              [clickableColumns]="['batchInstanceId']"
              (rowCellClicked)="onCellClicked($event)"
              (actionInvoked)="onListAction($event)"
            >
              <ng-template #rowActions let-rowData="rowData">
                <div class="custom-row-actions">
                  <div class="custom-row-actions__container">
                    <ppl-button
                      size="small"
                      [ariaLabel]="'View Results'"
                      label="Results"
                      icon="fa fa-eye"
                      [customClass]="'ghost-button'"
                      [iconPosition]="'left'"
                      [hideLabel]="false"
                      (click)="onViewResults(rowData?.batchInstanceId)">
                    </ppl-button>

                    <!-- <ppl-button
                      size="small"
                      [ariaLabel]="'View Errors'"
                      label="Errors"
                      icon="fa fa-exclamation-triangle"
                      [customClass]="'ghost-button'"
                      [iconPosition]="'left'"
                      [hideLabel]="false"
                      (click)="onViewErrors(rowData?.batchInstanceId)">
                    </ppl-button> -->
                  </div>
                </div>
              </ng-template>
            </ppl-list-table>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Approve / reject the selected payroll runs -->
<ppl-popup-dialog
  [(isVisible)]="showStatusDialog"
  [title]="statusDialogTitle"
  [showClose]="true"
  [showButtons]="true"
  [showOkButton]="false"
  [hideSaveButton]="isConfirmBlocked"
  size="medium"
  position="center"
  (confirm)="onStatusConfirm()">
  <div>
    @if (dialogType === 'warning') {
      <p class="dialog-intro">{{ warningMessage }}</p>
    } @else {
      <p class="dialog-intro">
        Are you sure you want to {{ dialogType === 'approval' ? 'approve' : 'reject' }} the selected payroll run(s)?
      </p>
      @if (selectedRows.length) {
        <p><strong>Selected records: {{ selectedRows.length }}</strong></p>
      }
      <div class="comment-section">
        <label [attr.for]="dialogType + 'Comments'">
          <strong>Comments@if (dialogType === 'rejection') {<span class="required-marker"> *</span>}</strong>
        </label>
        <textarea
          [id]="dialogType + 'Comments'"
          [(ngModel)]="comments"
          [placeholder]="dialogType === 'approval' ? 'Add comments (optional)' : 'Please provide a reason for rejection (required)'"
          rows="4"
          class="dialog-textarea">
        </textarea>
      </div>
    }
  </div>
</ppl-popup-dialog>
